export default __webpack_public_path__ + "1.17.16/static/media/close.2fccb63b.svg";